import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';

import { getAuthToken } from 'actions/api';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const messages = defineMessages({
  PDF_EXPORT: {
    id: 'PdfExportButton.PDF_EXPORT',
    defaultMessage: 'PDF-Export',
  },
  PDF_EXPORT_TOOLTIP: {
    id: 'PdfExportButton.PDF_EXPORT_TOOLTIP',
    defaultMessage: 'Diese PDF-Funktion erstellt ein chronologisches Protokoll über ein oder mehrere geführte Gespräche. Im Gegensatz zum Service-Protokoll ist hierbei keine Unterschrift möglich. Es dokumentiert zudem sämtliche Aktivitäten und Gespräche, die innerhalb des ausgewählten Projektordners (siehe linke Leiste) gespeichert wurden.',
  },
});

/* global document */
/* global window */
function PdfExportButton({
  customer,
  locale,
  selectedOrderId,
  intl: { formatMessage },
}) {
  const orderPart = selectedOrderId > 0 ? `order/${selectedOrderId}/` : '';
  const pdfLocation = `/api/company/${customer.company_id}/customer/${customer.id}/${orderPart}pdf`;
  const token = `Bearer ${getAuthToken()}`;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
      <button
        onClick={() => {
          const cookieOptions = '; path=/api/; max-age=600';
          document.cookie = `Authorization=${token}${cookieOptions}`;
          document.cookie = `User-Locale=${locale}${cookieOptions}`;
          window.location = pdfLocation;
        }}
        className="lh-btn lh-btn-small lh-btn-default"
        style={{ height: '34px', boxSizing: 'border-box' }}
        title={formatMessage(messages.PDF_EXPORT)}
      >
        <i className="fa fa-file-pdf-o" style={{ fontSize: 15 }} /> PDF
      </button>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="pdf-export-tooltip" style={{ maxWidth: 320, textAlign: 'left', fontSize: 12 }}>
            {formatMessage(messages.PDF_EXPORT_TOOLTIP)}
          </Tooltip>
        }
      >
        <span style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          width: 16, 
          height: 16, 
          borderRadius: '50%', 
          background: 'var(--primary-color)', 
          color: 'white', 
          fontSize: 11, 
          fontWeight: 'bold', 
          cursor: 'help',
          marginLeft: '8px'
        }}>?</span>
      </OverlayTrigger>
    </div>
  );
}

export default connect(state => ({ locale: state.intl.locale }))(
  injectIntl(PdfExportButton)
);
